export const getInitialState = () => ({
	channelReportOptions: null,
	channelReport: null,
	selectedPeriod: -1,
	features: {}
});
